import { FC, useMemo } from "react";
import { useFlag } from "@unleash/proxy-client-react";
import Stack from "@mui/material/Stack";
import { TypographyWithTooltip } from "../../../../../../common/TypographyWithTooltip";
import {
  PossibleFilterValues,
  ResourceExplorerGroupingNullable,
} from "../../../../../../../services/cloudchipr.api";
import { useAppSelector } from "../../../../../../../store/hooks";
import { resourceExplorerGroupingLabelByGroupingSelector } from "../../../../../../../store/resource-explorer/selectors/possible-groupings/resourceExplorerGroupingLabelByGroupingSelector";
import { generateBillingExplorerGroupingLabel } from "@/components/pages/common/resource-explorer-grouping-selector-v2/components/triggers/utils/helpers";
import { GroupingOptionIcon } from "@/components/pages/common/resource-explorer-grouping-selector-v2/components/GroupingOptionIcon";

interface AlertsCostAnomalyDataGridGroupingCellProps {
  grouping: ResourceExplorerGroupingNullable;
  groupValues?: string[];
  dimensionPossibleFilters?: PossibleFilterValues;
}

export const AlertsCostAnomalyDataGridGroupingCell: FC<
  AlertsCostAnomalyDataGridGroupingCellProps
> = ({ grouping, groupValues, dimensionPossibleFilters }) => {
  const enableCategoryGroupingFilterV2 = useFlag(
    "EnableCategoryGroupingFilterV2",
  );
  const categoryGroupKey = enableCategoryGroupingFilterV2
    ? "category_v2"
    : "category";

  const groupingLabel = useAppSelector((state) =>
    resourceExplorerGroupingLabelByGroupingSelector(state, grouping),
  );

  const label = useMemo(() => {
    return generateBillingExplorerGroupingLabel({
      grouping,
      groupValues,
      groupingLabel,
      dimensionPossibleFilters,
      enableCategoryGroupingFilterV2,
    });
  }, [
    grouping,
    groupValues,
    groupingLabel,
    dimensionPossibleFilters,
    enableCategoryGroupingFilterV2,
  ]);

  if (!label?.length) {
    return null;
  }
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <GroupingOptionIcon grouping={grouping} />
      <TypographyWithTooltip variant="inherit" title={label} />
    </Stack>
  );
};
